module.exports = __webpack_public_path__ + "img/officialAccount.1bdceb34.jpg";